import type { SyntheticEvent } from "react";
import React from "react";
import * as Styles from "./CarouselImage.styles";
import { useLoadImage } from "../../../../../../common-deprecated/hooks";
import { useUscSelector } from "../../../../redux/store";
import ThreeSixtyOverlay from "./ThreeSixtyOverlay";
import CarouselPlaceholderImage from "./CarouselPlaceholderImage";
import { enable360Spin } from "../../../../utils/pdpUtils";

type CarouselImageType = {
    index: number;
    amountOfImages: number;
    altTag: string;
    src: string;
    srcSet?: string;
    onClick?: (event: SyntheticEvent) => void;
    startLoading: boolean;
};

const CarouselImage = (props: CarouselImageType): JSX.Element => {
    const { src, altTag, srcSet, onClick, index, startLoading } = props;
    const { amountOfImages } = props;

    const result = useUscSelector((state) => state.vehicle.result);
    const aspectRatio = useUscSelector((state) => state.uscSettings.aspectRatio);
    const objectFit = useUscSelector((state) => state.uscSettings.objectFit);

    const { imageLoaded } = useLoadImage(startLoading, src, srcSet);

    const has360Spin = enable360Spin(result);

    return (
        <Styles.Wrapper
            id={`slide-pdp-${index}`}
            singleImage={amountOfImages < 2}
            className="scrollable-element"
            onClick={onClick}
        >
            {startLoading ? (
                <Styles.Image
                    src={src}
                    srcSet={srcSet}
                    show={imageLoaded}
                    alt={altTag}
                    data-aspect-ratio={aspectRatio}
                    objectFit={objectFit}
                />
            ) : (
                <CarouselPlaceholderImage />
            )}

            <Styles.Content>{has360Spin && index === 0 && <ThreeSixtyOverlay />}</Styles.Content>
        </Styles.Wrapper>
    );
};

export default CarouselImage;
